import React from 'react';
import cronParser from 'cron-parser';
import {
  GECKO_CONSTS,
  GeckoAvatar,
  GeckoCardTable,
  GeckoModal,
  GeckoModalService,
  GeckoToastService,
} from 'ui';
import GeckoDate from 'services/gecko-date';
import GeckoPermissions from 'services/gecko-permissions';
import GeckoRequest from 'services/gecko-request';
import GeckoLocation from 'services/gecko-location';
import { renderError } from 'services/gecko-error';
import { useRedux } from 'services/gecko-store/redux';
import { fetchExports } from './actions';

const removeExport = (exportInstance) => {
  new GeckoModalService().open(() => {
    return (
      <GeckoModal
        name="Delete Export"
        children={<p>Are you sure you want to remove this export?</p>}
        btns={[
          {
            icon: 'fas fa-times',
            name: 'Cancel',
            handler: () => {
              new GeckoModalService().close();
            },
          },
          {
            icon: 'fas fa-trash',
            type: GECKO_CONSTS.BTN_TYPE_DANGER,
            name: 'Delete',
            handler: () => {
              new GeckoModalService().close();
              return GeckoRequest.delete(`/exports/${exportInstance.id}`)
                .then(() => {
                  new GeckoToastService().success('Export removed');
                  return fetchExports();
                })
                .catch(renderError);
            },
          },
        ]}
      />
    );
  });
};

const openExportEditor = (exportId) => {
  const exportPage = exportId ? exportId : 'new';
  return GeckoLocation.goTo(`/settings/exports/${exportPage}`);
};

const headerBtn = {
  name: 'Create an Export',
  icon: 'fas fa-plus',
  handler: openExportEditor.bind(null, null),
};

export function RecurringExportsCard() {
  const exports = useRedux((state) => state.recurring_exports);
  const agents = useRedux((state) => state.agents);

  const cols = [
    {
      key: 'name',
      name: 'Name',
      width: '45%',
      sortable: true,
    },
    {
      key: 'lastRun',
      name: 'Last Run',
      width: '10%',
      render: (date) => (date ? new GeckoDate(date).LONG_TIME : '-'),
    },
    {
      key: 'nextRun',
      name: 'Next Run',
      width: '10%',
      render: (cron) => {
        if (cron) {
          const dateFromCron = cronParser.parseExpression(cron).next().toDate();
          return new GeckoDate(dateFromCron).LONG_TIME;
        }
        return '-';
      },
    },
    {
      key: 'createdBy',
      name: 'Created By',
      sortable: 'full_name',
      render: (createdBy) => {
        const agent = agents.find((agent) => agent.id === createdBy);
        return agent ? (
          <div>
            <GeckoAvatar
              name={agent.full_name}
              first_name={agent.first_name}
              last_name={agent.last_name}
              color={agent.additional.avatar_colour}
            />
            <span>&nbsp;{agent.full_name}</span>
          </div>
        ) : (
          'Gecko Support'
        );
      },
      width: '20%',
    },
    {
      key: 'dateCreated',
      name: 'Date Created',
      width: '10%',
      render: (date) => (date ? new GeckoDate(date).LONG_TIME : '-'),
    },
    {
      type: GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN,
      width: '4%',
      items: [
        {
          name: 'Edit',
          handler: ({ id }) => openExportEditor(id),
        },
        {
          name: 'Remove',
          handler: removeExport,
        },
      ],
    },
  ];

  return (
    <GeckoCardTable
      name="Recurring Exports"
      cols={cols}
      rows={exports}
      pagination={false}
      alert="You don't have any recurring exports at the moment."
      newLinkHandler={openExportEditor}
      headerBtns={
        GeckoPermissions.memberOf('admin') ||
        GeckoPermissions.memberOf('supervisor')
          ? [headerBtn]
          : null
      }
    />
  );
}
